import React from 'react';

import { scrollTop } from '@share/utils';
import { GetawayList } from '@components';

import './style.scss';

interface IProps {
  isInternal: boolean;
}

export class GetawayListPage extends React.Component<IProps, null> {
  constructor(props: IProps) {
    super(props);

    scrollTop();
  }

  render(): React.ReactNode {
    return <GetawayList isInternal={this.props.isInternal} />;
  }
}
